import localEn from './lang/es.json';
import localAr from './lang/ar.json';
import localEs from './lang/es.json';
import localDe from './lang/de.json';
import localCn from './lang/zh.json';
import localIl from './lang/he.json';

export const messages = {
  en: localEn,
  ar: localAr,
  es: localEs,
  de: localDe,
  zh: localCn,
  he: localIl,
};
